import { Link } from 'react-router-dom';
import { categories, comics } from '@/mocks/comics';

export default function CategoryShowcase() {
  return (
    <section className="py-14 md:py-18" aria-label="漫画分类展示">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">漫画分类</h2>
          <p className="text-sm text-foreground-500 mt-1">按类型发现你喜欢的漫画</p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {categories.filter(c => c !== '全部').map((cat) => (
            <Link
              key={cat}
              to={`/category/${cat}`}
              className="px-5 py-2 rounded-full text-sm font-medium bg-secondary-100 text-secondary-700 hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              {cat}
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.filter(c => c !== '全部').slice(0, 6).map((cat) => {
            const catComics = comics.filter(c => c.categories.includes(cat));
            return (
              <Link
                key={cat}
                to={`/category/${cat}`}
                className="group block bg-background-50 rounded-lg border border-background-200 p-5 hover:border-primary-300 transition-all cursor-pointer"
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                      <i className="ri-bookmark-line text-primary-600 text-lg"></i>
                    </div>
                    <h3 className="font-heading text-base font-bold text-foreground-900">{cat}</h3>
                  </div>
                  <span className="text-xs text-foreground-500 bg-background-100 px-2 py-1 rounded-full">
                    {catComics.length}部
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mb-3">
                  {cat === '热血' && '燃爆全场的战斗与冒险故事'}
                  {cat === '恋爱' && '甜蜜心动的浪漫爱情故事'}
                  {cat === '玄幻' && '异界大陆的奇幻冒险之旅'}
                  {cat === '搞笑' && '轻松幽默的欢乐日常故事'}
                  {cat === '悬疑' && '扣人心弦的推理与谜题'}
                  {cat === '科幻' && '未来世界的科技幻想故事'}
                  {cat === '校园' && '青春洋溢的校园生活故事'}
                  {cat === '竞技' && '热血沸腾的竞技比拼故事'}
                  {cat === '日常' && '温暖治愈的日常生活故事'}
                  {cat === '历史' && '波澜壮阔的历史传奇故事'}
                </p>
                <div className="flex items-center gap-2 text-xs text-primary-600">
                  <span>浏览全部</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}